"use strict";

require("core-js/modules/es6.regexp.to-string");

require("core-js/modules/es6.date.to-string");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.regexp.replace");

require("core-js/modules/es6.string.trim");

require("core-js/modules/es6.number.constructor");

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.stringToNumber = void 0;

var stringToNumber = function stringToNumber(value) {
  return value ? Number(value.toString().replace(/\D+/g, '').trim()) : 0;
};

exports.stringToNumber = stringToNumber;